export default {
  model: [
    {
      label: 'Título',
      field: 'title',
      type: 'text'
    },
    {
      label: 'Texto',
      field: 'content',
      type: 'text'
    },
    {
      label: 'Número/Ano',
      field: 'number_law',
      type: 'text'
    },
    {
      label: 'Permissão de acesso',
      field: 'magazines',
      type: 'array'
    },
    {
      label: 'Categoria',
      field: 'legislation_category_id',
      type: 'text'
    }
  ]
}